"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _responsive = require("../responsive");

var _utils = require("../utils");

var _getUniqueId = require("../utils/getUniqueId");

var _screenReaderOnly = require("../screen-reader-only");

var _popover = require("../popover");

var _layout = require("../layout");

var _TooltipText = _interopRequireDefault(require("./TooltipText"));

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var convertToPopoverPosition = function convertToPopoverPosition(position, alignment) {
  if (position === _interfaces.TOOLTIP_POSITION.TOP) {
    if (alignment === _interfaces.TooltipAlignment.Left) {
      return _popover.PopoverPosition.TopLeading;
    } else if (alignment === _interfaces.TooltipAlignment.Right) {
      return _popover.PopoverPosition.TopTrailing;
    } else {
      return _popover.PopoverPosition.TopCenter;
    }
  } else {
    if (alignment === _interfaces.TooltipAlignment.Left) {
      return _popover.PopoverPosition.BottomLeading;
    } else if (alignment === _interfaces.TooltipAlignment.Right) {
      return _popover.PopoverPosition.BottomTrailing;
    } else {
      return _popover.PopoverPosition.BottomCenter;
    }
  }
};

var TooltipProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TooltipProvider, _React$PureComponent);

  function TooltipProvider() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TooltipProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TooltipProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      id: "StencilReactTooltip-".concat((0, _getUniqueId.getUniqueId)()),
      isOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "triggerRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tooltipRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "open", function () {
      _this.setState({
        isOpen: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "close", function () {
      _this.setState({
        isOpen: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TooltipProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$tooltipPo = _this$props.tooltipPosition,
          tooltipPosition = _this$props$tooltipPo === void 0 ? _interfaces.TOOLTIP_POSITION.TOP : _this$props$tooltipPo,
          _this$props$tooltipAl = _this$props.tooltipAlignment,
          tooltipAlignment = _this$props$tooltipAl === void 0 ? _interfaces.TooltipAlignment.Center : _this$props$tooltipAl,
          tooltipText = _this$props.tooltipText,
          tooltipDataTestId = _this$props.tooltipDataTestId,
          children = _this$props.children;
      var _this$state = this.state,
          id = _this$state.id,
          isOpen = _this$state.isOpen;
      var triggerRef = this.triggerRef,
          tooltipRef = this.tooltipRef;
      var dataTestProps = (0, _utils.buildDataTestProps)({
        dataTestComponent: 'StencilReactTooltip',
        dataTestId: tooltipDataTestId
      });
      var position = convertToPopoverPosition(tooltipPosition, tooltipAlignment);
      return (0, _core.jsx)(_responsive.WithBreakpoints, null, function (viewport) {
        var maxWidth = viewport.matches.s ? "calc(100vw - ".concat(_constants.MARGIN_MOBILE * 2, "px)") : _constants.MAX_WIDTH_DESKTOP;
        return (0, _core.jsx)(_react.default.Fragment, null, children({
          triggerRef: triggerRef,
          tooltipRef: tooltipRef,
          open: _this2.open,
          close: _this2.close,
          isOpen: isOpen,
          tooltipId: id
        }), !isOpen && (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
          "aria-hidden": true,
          id: id
        }, tooltipText), (0, _core.jsx)(_popover.PopoverController, {
          target: triggerRef,
          isOpen: isOpen,
          close: _this2.close,
          position: position,
          shouldFocusOnOpen: false,
          shouldCloseOnFocusLeave: false
        }, (0, _core.jsx)(_layout.View, {
          padding: "S300",
          maxWidth: maxWidth,
          ref: tooltipRef
        }, (0, _core.jsx)(_TooltipText.default, (0, _extends2.default)({
          role: "tooltip",
          id: id,
          "aria-hidden": true
        }, dataTestProps), tooltipText))));
      });
    }
  }]);
  return TooltipProvider;
}(_react.default.PureComponent);

(0, _defineProperty2.default)(TooltipProvider, "displayName", 'TooltipProvider');
(0, _defineProperty2.default)(TooltipProvider, "defaultProps", {
  tooltipPosition: _interfaces.TOOLTIP_POSITION.TOP,
  tooltipAlignment: _interfaces.TooltipAlignment.Center
});
var TooltipProviderWithDocs = (0, _stencilReactDesc.describe)(TooltipProvider).description('FAC component which displays tooltips.');
TooltipProviderWithDocs.propTypes = {
  isInline: _stencilReactDesc.PropTypes.bool.description('Indicates that the tooltip is inline in a sentence.'),
  tooltipText: _stencilReactDesc.PropTypes.string.isRequired.description('Plain string to display in the tooltip.'),
  tooltipPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.TOOLTIP_POSITION)).description('Vertical position for the tooltip relative to the trigger.'),
  tooltipAlignment: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.TooltipAlignment)).description('Horizontal alignment for the tooltip relative to the trigger.'),
  tooltipDataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM for the tooltip content."),
  children: _stencilReactDesc.PropTypes.func.isRequired.description('Render function which renders the trigger for the tooltip.').format("({\n  open: function,\n  close: function,\n  isOpen: boolean,\n  tooltipId: string\n}) => node")
};
var _default = TooltipProviderWithDocs;
exports.default = _default;